import { useEffect, useRef, useState } from 'react';

const relatedItems = [
  {
    icon: 'ri-t-shirt-2-line',
    title: '企画・制作',
    description:
      '衣料品や繊維製品を中心に、日常で使いやすい手づくりアイテムの企画・制作を行っています。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20clothing%20display%20with%20natural%20cotton%20and%20linen%20garments%2C%20contemporary%20fashion%20photography%20with%20clean%20white%20background%2C%20simple%20elegant%20clothing%20arrangement%20with%20warm%20natural%20lighting%2C%20refined%20textile%20photography%20with%20earth%20tone%20colors%2C%20stylish%20everyday%20wear%20presentation&width=400&height=300&seq=modern-clothing&orientation=landscape',
  },
  {
    icon: 'ri-handbag-line',
    title: '生活雑貨・装身具',
    description:
      'アクセサリー、バッグ、文房具など、暮らしに寄り添うアイテムを幅広く取り扱う事業も展開しています。',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20handcrafted%20accessories%20and%20jewelry%20display%20with%20minimalist%20aesthetic%2C%20contemporary%20accessory%20photography%20with%20clean%20background%2C%20refined%20handmade%20jewelry%20arrangement%20with%20natural%20lighting%2C%20modern%20craftsmanship%20with%20earth%20tone%20colors%2C%20stylish%20accessories%20presentation&width=400&height=300&seq=modern-accessories&orientation=landscape',
  },
  {
    icon: 'ri-brush-line',
    title: 'オーダー相談',
    description:
      '用途やイメージに合わせた企画相談にも対応し、既存事業として一点ものの制作や個別相談を受け付けています。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20stationery%20and%20paper%20goods%20display%20with%20minimalist%20design%2C%20contemporary%20stationery%20photography%20with%20clean%20background%2C%20elegant%20notebook%20and%20writing%20tools%20arrangement%2C%20refined%20paper%20crafts%20with%20natural%20lighting%2C%20stylish%20office%20supplies%20presentation&width=400&height=300&seq=modern-stationery&orientation=landscape',
  },
];

export default function RelatedBusinessSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="related-business" className="bg-[#11141a] py-24 md:py-32" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          className={`flex flex-col lg:flex-row gap-12 items-end mb-14 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex-1">
            <span className="text-xs font-semibold tracking-widest text-[#38bdf8] uppercase mb-3 block">Related Business</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              関連事業
            </h2>
          </div>
          <div className="flex-1">
            <p className="text-gray-300 text-[15px] leading-relaxed">
              K・Sキャピタルでは、クラウド型経理システム事業に加えて、
              既存事業として手づくり商品の企画・制作に関する取り組みも行っています。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {relatedItems.map((item, index) => (
            <div
              key={item.title}
              className={`rounded-2xl border border-white/8 bg-[#171b22] p-6 transition-all duration-500 hover:border-[#38bdf8]/35 hover:bg-[#1b2029] ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 90 + 150}ms` }}
            >
              <div className="mb-5 overflow-hidden rounded-xl border border-white/8">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-44 w-full object-cover object-top"
                />
              </div>
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-[#38bdf8]/10">
                <i className={`${item.icon} text-[#38bdf8] text-xl`} />
              </div>
              <h3 className="mb-3 text-lg font-semibold text-white">{item.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div
          className={`mt-10 rounded-2xl border border-[#38bdf8]/15 bg-[#0f1115] p-6 md:p-7 transition-all duration-700 delay-300 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
            <div>
              <p className="text-white text-lg font-semibold mb-2">別事業についてもご案内可能です</p>
              <p className="text-gray-300 text-[15px] leading-relaxed">
                詳細は今後整理予定ですが、現時点でも内容確認やご相談ベースでのご案内は可能です。
              </p>
            </div>
            <button
              onClick={scrollToContact}
              className="px-6 py-3 rounded-md bg-gradient-to-r from-[#0ea5e9] to-[#38bdf8] text-white font-semibold text-[15px] hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
            >
              関連事業について問い合わせる
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
